/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { usePreviewProvider } from 'modules/processes/components/ItemWizard/Providers/preview'
import { ToogleCard } from 'modules/processes/components/ItemWizard/components/Form/Items/ToogleCard'
import { DataCollectionCategories } from 'modules/processes/domain'

const UploadId = () => {
  const [requestIdData, setRequestIdData] = useState({})
  const { setPreviewValues, previewValues } = usePreviewProvider()
  const { associatedTaskItem: item, form, changeValue } = useFormProvider()

  const dataCollectionConfig = form.get('data_collection_configuration').value
  const field = form.get('data_collection_configuration')

  const uploadIdCertificate = dataCollectionConfig.uploadIdCertificate
  const uploadSocialSecurityCertificate = dataCollectionConfig.uploadSocialSecurityCertificate

  useUnsafeEffect(() => {
    const taskConfiguration = item?.taskTypeConfiguration
      ? JSON.parse(item?.taskTypeConfiguration)
      : {}
    const category = taskConfiguration.configuration_fields?.at(0)?.categories?.at(0)
    const isUploadIdCollector = category?.category === DataCollectionCategories.identificationNumber

    const enabled = isUploadIdCollector ? !!category.configuration?.folder_id : true
    const enableUploadIdCertificate = isUploadIdCollector
      ? !!category.configuration?.onboarding_folder_id
      : true

    const data = {
      uploadIdCertificate: previewValues.requestId
        ? previewValues.requestId?.uploadIdCertificate
        : enabled,
      uploadSocialSecurityCertificate: previewValues.requestId
        ? previewValues.requestId?.uploadSocialSecurityCertificate
        : enableUploadIdCertificate,
    }
    setRequestIdData(data)
    setPreviewValues({
      requestId: data,
    })
    field.set(data)
    changeValue('data_collection_configuration', data)
  }, [])

  const updateDataCollectionConfig = (key: string, value: boolean) => {
    const data = {
      ...requestIdData,
      [key]: value,
    }
    setRequestIdData(data)
    setPreviewValues({
      requestId: data,
    })
    changeValue('data_collection_configuration', data)
  }

  return (
    <Box gap="s16">
      <ToogleCard
        title={i18n.t(
          'processes.process_settings.wizard.tasks.types.request_id.form.upload_id.title'
        )}
        tooltip={i18n.t(
          'processes.process_settings.wizard.tasks.types.request_id.form.upload_id.tooltip'
        )}
        tooglerValue={uploadIdCertificate}
        onChange={() => updateDataCollectionConfig('uploadIdCertificate', !uploadIdCertificate)}
      />
      <ToogleCard
        title={i18n.t(
          'processes.process_settings.wizard.tasks.types.request_id.form.upload_social_security.title'
        )}
        tooltip={i18n.t(
          'processes.process_settings.wizard.tasks.types.request_id.form.upload_social_security.tooltip'
        )}
        tooglerValue={uploadSocialSecurityCertificate}
        onChange={() =>
          updateDataCollectionConfig(
            'uploadSocialSecurityCertificate',
            !uploadSocialSecurityCertificate
          )
        }
      />
    </Box>
  )
}

export default UploadId
